import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  link: {
    textDecoration: "none",
    height: 68,
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingLeft: 27,
    borderBottom: "solid 1px #eee",
    borderRadius: 0,
    [theme.breakpoints.down("md")]: {
      height: 94,
      paddingLeft: 8
    },
    [theme.breakpoints.down("xs")]: {
      height: 52
    }
  },
  listItemSelected: {
    backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    border: "none",
    outline: `1px solid ${theme.palette.text.hint}`,
    "& $icon": {
      color: theme.palette.text.primary
    }
  },
  listItemText: {
    fontSize: 16,
    lineHeight: 1,
    textTransform: "capitalize",
    marginLeft: 20,
    [theme.breakpoints.down("md")]: {
      display: "none"
    },
    [theme.breakpoints.down("xs")]: {
      display: "block",
      fontSize: 18,
      color: theme.palette.text.secondary
    }
  },
  icon: {
    fontSize: 22,
    color: theme.palette.text.hint,
    [theme.breakpoints.down("md")]: {
      fontSize: 26,
      minWidth: "auto",
      margin: "0 auto"
    },
    [theme.breakpoints.down("xs")]: {
      margin: "0 0 0 12px"
    }
  }
}));
